import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { useLocation } from "react-router-dom";
import { post } from "../../../Services/ApiHandler";
import { green_icon, red_icon, user } from "../../../assets/imgs";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import moment from "moment";
import { URL } from "../../../Services/Constant";
import CommonImagePopup from "../../../components/CommonImagePopup";

const GroupUsers = () => {
  const [site, setSite] = useState({});
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [siteData, setSiteData] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [alertDataType, setAlertDataType] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [groupCat, setGroupCat] = useState({});
  const [createdAt, setCreatedAt] = useState("");
  const [list, setList] = useState({});
  const [open, setOpen] = useState();
  // const { type, data } = location.state;

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    setSelectedCompany(company_id);
    let formdata = new FormData();
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
          setSite({});
          setAlertData([]);
          setAlertDataType([]);
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteUser = (site_id) => {
    let formdata = new FormData();
    formdata.append("company_id", selectedCompany?.value);
    formdata.append("site_id", site_id);
    post(URL.COMPANY_SITE_USER_LIST, formdata)
      .then((res) => {
        if (res?.data?.length > 0) {
          let data_ = res?.data?.[0];
          setList(data_);
          if (data_?.admin_created_at) {
            setCreatedAt(moment(data_?.admin_created_at).format("DD-MM-YYYY"));
          }
          let groupUsers = data_?.users;
          let groupCat_ = {};
          if (groupUsers?.length > 0) {
            for (let i of groupUsers) {
              let key = i.knf_type;
              if (!groupCat_[key]) {
                groupCat_[key] = [];
              }
              groupCat_[key].push(i);
              setGroupCat(groupCat_);
            }
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  console.log("group cat", groupCat, selectedCompany, selectedOption);
  return (
    <div className="dashRightView">
      <StatusComp name={"Group Users"} hide={true} />
      <div className={`d-flex w-100 ac-js mb-4`}>
        {/* Company Select */}
        <div className="">
          <label className="form-label">Select Company</label>
          <SelectBox
            arrayData={comapanyList}
            data={company}
            setData={setCompany}
            selectedOption={selectedCompany}
            setSelectedOption={(val) => {
              getSiteList(val);
              setSelectedOption(null);
              setGroupCat({});
            }}
            style={true}
            isClearable={false}
          />
        </div>

        {/* Site Select */}
        <div className=" mx-4">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            data={siteData}
            setData={setSiteData}
            selectedOption={selectedOption}
            setSelectedOption={(val) => {
              setSelectedOption(val);
              getSiteUser(val?.value);
              setGroupCat({});
            }}
            isClearable={false}
            disabled={selectedCompany?.label ? false : true}
            style={true}
          />
        </div>
      </div>
      <div className="row d-flex flex-wrap align-items-start justify-content-between">
        {Object.keys(groupCat).length == 0 && (
          <div className="card shadow-sm border-0 rounded-4 mt-5">
            <div className="card-body text-center py-5">
              <div className="mb-3">
                <div className="bg-light rounded-circle d-inline-flex p-4">
                  <i className="bi bi-person-video3 fs-1 text-muted"></i>
                </div>
              </div>
              <h5 className="text-muted mb-2">No group user found</h5>
              <p className="text-muted small mb-0">
                Please select company and site to add/view/edit group users
              </p>
            </div>
          </div>
        )}
        <div className="col-md-4">
          {groupCat?.[3]?.length > 0 && (
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
              Group-1 ({groupCat?.[3]?.length})
            </p>
          )}
          <div className="w-100 ">
            {groupCat?.[3]?.map((item, ind) => {
              return (
                <div
                  key={ind}
                  className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                >
                  <div className="d-flex ac-jb">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Name
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.name}
                      />
                    </div>
                    <img
                      src={
                        item?.profile_image?.name
                          ? URL.createObjectURL(item.profile_image)
                          : item?.profile_image
                            ? item.profile_image
                            : user
                      }
                      alt=""
                      className="user mb-1 pointer"
                      style={{
                        height: "70px",
                        width: "70px",
                        borderRadius: "35px",
                      }}
                      onClick={() => setOpen(item?.profile_image)}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Email
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.email}
                    />
                    <div className="d-flex ac-js mt-2 gap-2">
                      <img
                        src={item?.is_email_verified ? green_icon : red_icon}
                        className="redImg"
                      />
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        {item?.is_email_verified ? "Verified" : "Not Verified"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Mobile
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.phone}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Created On
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={
                        item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : ""
                      }
                    />
                  </div>

                  <div className="d-flex ac-jb gap-3">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Alert Notifications
                      </p>
                      {item?.notification_alert ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Beep Sound
                      </p>
                      {item?.beep_sound ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-md-4">
          {groupCat?.[4]?.length > 0 && (
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
              Group-2 ({groupCat?.[4]?.length})
            </p>
          )}
          <div className="w-100 ">
            {groupCat?.[4]?.map((item, ind) => {
              return (
                <div
                  key={ind}
                  className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                >
                  <div className="d-flex ac-jb">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Name
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.name}
                      />
                    </div>
                    <img
                      src={
                        item?.profile_image?.name
                          ? URL.createObjectURL(item.profile_image)
                          : item?.profile_image
                            ? item.profile_image
                            : user
                      }
                      alt=""
                      className="user mb-1 pointer"
                      style={{
                        height: "70px",
                        width: "70px",
                        borderRadius: "35px",
                      }}
                      onClick={() => setOpen(item.profile_image)}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Email
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.email}
                    />
                    <div className="d-flex ac-js mt-2 gap-2">
                      <img
                        src={item?.is_email_verified ? green_icon : red_icon}
                        className="redImg"
                      />
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        {item?.is_email_verified ? "Verified" : "Not Verified"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Mobile
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.phone}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Created On
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={
                        item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : ""
                      }
                    />
                  </div>

                  <div className="d-flex ac-jb gap-3">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Alert Notifications
                      </p>
                      {item?.notification_alert ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Beep Sound
                      </p>
                      {item?.beep_sound ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-md-4">
          {groupCat?.[5]?.length > 0 && (
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
              Group-3 ({groupCat?.[5]?.length})
            </p>
          )}
          <div className="w-100 ">
            {groupCat?.[5]?.map((item, ind) => {
              return (
                <div
                  key={ind}
                  className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                >
                  <div className="d-flex ac-jb">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Name
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.name}
                      />
                    </div>
                    <img
                      src={
                        item?.profile_image?.name
                          ? URL.createObjectURL(item.profile_image)
                          : item?.profile_image
                            ? item.profile_image
                            : user
                      }
                      alt=""
                      className="user mb-1 pointer"
                      style={{
                        height: "70px",
                        width: "70px",
                        borderRadius: "35px",
                      }}
                      onClick={() => setOpen(item.profile_image)}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Email
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.email}
                    />
                    <div className="d-flex ac-js mt-2 gap-2">
                      <img
                        src={item?.is_email_verified ? green_icon : red_icon}
                        className="redImg"
                      />
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        {item?.is_email_verified ? "Verified" : "Not Verified"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Mobile
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.phone}
                    />
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Created On
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={
                        item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : ""
                      }
                    />
                  </div>

                  <div className="d-flex ac-jb gap-3">
                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Alert Notifications
                      </p>
                      {item?.notification_alert ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Beep Sound
                      </p>
                      {item?.beep_sound ? (
                        <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                      ) : (
                        <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {open && <CommonImagePopup setOpen={setOpen} img={open} />}
        </div>
      </div>
    </div>
  );
};

export default GroupUsers;
